"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCloserWrapper = void 0;
const lib_1 = require("@brandfree-front/lib");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const StoresUtil_1 = require("../../util/StoresUtil");
const mobx_1 = require("mobx");
const crm_components_1 = require("crm-components");
let ContactFormFooter = class ContactFormFooter extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "contactFormStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "emailStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isEmailSending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "submitOnClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                const { redirectUrlAfterSubmit } = this.props;
                this.isEmailSending = true;
                await this.emailStore.sendContactFormEmail(this.contactFormStore.emailContent);
                (0, mobx_1.runInAction)(() => {
                    this.isEmailSending = false;
                    this.contactFormStore.reset();
                });
                if (redirectUrlAfterSubmit) {
                    (0, crm_components_1.navigate)(redirectUrlAfterSubmit);
                }
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(lib_1.Grid, { align: ['middle-sm', 'end-sm'] },
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'sm'], className: "text-center" },
                react_1.default.createElement(exports.ModalCloserWrapper, { shouldWrap: this.props.isInsideModal, wrapper: (children) => react_1.default.createElement(lib_1.ModalCloser, null, children), children: react_1.default.createElement(GaButton_1.default, { disabled: !this.contactFormStore.captchaPassed || !this.contactFormStore.isEmailValid || !this.contactFormStore.isBodyValid, id: "contact-form-submit", text: translate('gdpr.privacy.contact.send'), iconRight: "#arrow-right", onClick: this.submitOnClick, isLoading: this.isEmailSending }) }))));
    }
};
__decorate([
    mobx_1.observable
], ContactFormFooter.prototype, "isEmailSending", void 0);
__decorate([
    mobx_1.action
], ContactFormFooter.prototype, "submitOnClick", void 0);
ContactFormFooter = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactFormFooter);
exports.default = ContactFormFooter;
const ModalCloserWrapper = (props) => {
    const { shouldWrap, wrapper, children } = props;
    return shouldWrap ? wrapper(children) : children;
};
exports.ModalCloserWrapper = ModalCloserWrapper;
